import React from "react";
import AboutAreaOne from "../components/AboutSection";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/Footer/Footer";
import NavBar from "../components/Navbar/NavBar";

const About = () => {
  return (
    <>
      <NavBar />
      <Breadcrumb title={"About Us"} />
      <AboutAreaOne />
      <FooterOne />
    </>
  );
};

export default About;
